module.exports = __webpack_public_path__ + "static/media/anysurfer.abee349f.svg";